import React from "react";
import * as Mui from "@mui/material";
import LockIcon from "@mui/icons-material/Lock";
import ShieldOutlinedIcon from "@mui/icons-material/ShieldOutlined";
import {
  AuthLayout,
  AuthLeftPanel,
  AuthRightPanel,
  AuthCard,
} from "../Login/AuthShell";
import { tokens, headingSx, primaryButtonSx } from "../Login/brandTokens";

export const InsufficientPermissions = () => {
  return (
    <React.Fragment>
      <AuthLayout>
        <AuthLeftPanel
          top={
            <Mui.Stack spacing={3} sx={{ maxWidth: 460 }}>
              <Mui.Typography
                sx={{
                  fontSize: { md: 32, lg: 42, xl: 48 },
                  fontWeight: 700,
                  lineHeight: 1.15,
                  letterSpacing: "-0.02em",
                }}
              >
                Access is
                <br />
                role-based
              </Mui.Typography>
              <Mui.Typography
                sx={{
                  fontSize: { md: 14, lg: 17, xl: 19 },
                  lineHeight: 1.5,
                  color: "rgba(255,255,255,0.72)",
                  maxWidth: 420,
                }}
              >
                Your administrator controls what each teammate can see. They
                can grant you access in a few clicks.
              </Mui.Typography>
            </Mui.Stack>
          }
        />

        <AuthRightPanel>
          <AuthCard
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              textAlign: "center",
            }}
          >
            <Mui.Box
              sx={{
                width: 64,
                height: 64,
                borderRadius: "50%",
                background: tokens.mintTint,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                mb: 3,
              }}
            >
              <LockIcon sx={{ fontSize: 32, color: tokens.primaryDark }} />
            </Mui.Box>

            <Mui.Typography sx={headingSx}>You need access</Mui.Typography>

            <Mui.Typography
              sx={{
                mt: 1.5,
                fontSize: 15,
                lineHeight: 1.5,
                color: "rgba(21,23,26,0.7)",
              }}
            >
              You do not have permission to access these records. Please
              contact your administrator for access. If you need further
              assistance, reach out to the support team.
            </Mui.Typography>

            <Mui.Box sx={{ mt: 3.5, width: "100%" }}>
              <Mui.Button variant="contained" sx={primaryButtonSx}>
                <ShieldOutlinedIcon sx={{ mr: 1.25, fontSize: 20 }} />
                Request access from admin
              </Mui.Button>
            </Mui.Box>
          </AuthCard>
        </AuthRightPanel>
      </AuthLayout>
    </React.Fragment>
  );
};
